import React, { useRef, useState } from "react";
import FilterTab from "../CommonComponents/FilterTab";
import HeaderOfWidget from "../CommonComponents/HeaderOfWidget";
import MapView from "../WareHouse/FindWarehouse/MapView";
import ScrollCard from "./ScrollCard";
import { eventTracker } from "../GATracker3.0/eventTracker";
import {
  PRODUCT_CLICKED,
  WAREHOUSE_CARD_CLICKED,
} from "../GATracker3.0/constants";
import { useLocation } from "react-router";
import { REQUIREMENT_CARD_CLICKED } from "../GATracker3.0/constants";
import { isMobile } from "../helperFunc";

import MapLegends from "../DesktopCommonComponents/MapLegends/MapLegends";
import style from "./style.module.css";
import { scroll } from "../CommonFunctions/Function";
import ScrollDeskArrow from "../CommonComponents/ScrollDeskArrow/ScrollDeskArrow";
const CommonSupplies = ({
  title,
  subtitle,
  data,
  showViewAll = true,
  cardClassName,
  isCardBottomRounded = true,
  onCardClick = () => null,
  similarLeadCard = false,
  showBookMark,
  aryaCertifiedCSS,
  onHeartClick = () => null,
  bookMarkClass,
  titleClassName = ``,
  isMylead,
  locationText2ClassName,
  isProductCard = false,
  isRequirementCard = false,
  subtitleClassName,
  rightTextClassName,
  desktopAddressOneLine,
  locationText1ClassName,
  onClick = () => null,
  isWarehouseDesktop = false,
  scrollClassName,
  desktopCSS = "",
  ...props
}) => {
  const location = useLocation();
  const isSupplyType =
    title === "Similar Supplies" || title === "Popular Supplies";

  const scrollRef = useRef();
  const [scrollX, setscrollX] = useState(0); // For detecting start scroll postion
  const [scrollEnd, setscrollEnd] = useState(false); // For detecting end of scrolling

  return (
    <div
      className={
        isMobile
          ? `backgroundLightBrown padding-top16`
          : `positionRelative ${style["top-bottom-margin-20"]} ${
              !isMobile && !isMylead ? "padding-top16" : ""
            }`
      }
    >
      <HeaderOfWidget
        title={title}
        subtitle={subtitle}
        rightText={showViewAll && !isMylead && "View All"}
        onClick={(e) => onClick()}
        location={props.location}
        titleClassName={titleClassName}
        subtitleClassName={subtitleClassName}
        rightTextClassName={rightTextClassName}
      />
      {props.selectedFilter ? (
        <FilterTab
          selectedFilter={props.selectedFilter}
          setSelectedFilter={props.setSelectedFilter}
          data={props.filterValues}
        />
      ) : (
        ""
      )}
      {title === "Warehouse Near Me" ? (
        <>
          <MapView
            wh_Arr={props.dataObj}
            className={`homeWarehouseWidget ${
              isMobile ? "margin-left16 margin-right16" : ""
            } margin-bottom16`}
            zoomIndex={props.zoomIndex}
            showInfoIcon={false}
          />
          {isMobile ? "" : <MapLegends />}
        </>
      ) : (
        ""
      )}
      <div
        className={
          isMobile
            ? `scrollHorizontal margin-left16  ${scrollClassName}`
            : `scrollHorizontal scroll-smooth-behaviour positionRelative
               ${
                 isWarehouseDesktop
                   ? `padding-top20 padding-left16 padding-bottom4 ${style["desktopWarehouse"]}`
                   : ""
               }`
        }
        ref={scrollRef}
        onScroll={() => scroll(setscrollX, scrollRef, setscrollEnd)}
      >
        {data.map((item) => {
          return (
            <ScrollCard
              onClick={(e) => {
                if (title === "Warehouse Near Me") {
                  eventTracker("event", WAREHOUSE_CARD_CLICKED, {
                    pagename:
                      location.pathname === "/"
                        ? "homepage"
                        : location.pathname,
                    warehouse_type: item.aryaCertified
                      ? "certified"
                      : "noncertified",
                  });
                }
                if (isRequirementCard) {
                  eventTracker("event", REQUIREMENT_CARD_CLICKED, {
                    pagename:
                      location.pathname === "/"
                        ? "homepage"
                        : location.pathname,
                    requirement_type: isSupplyType
                      ? "supply_type"
                      : "demand_type",
                  });
                }
                if (isProductCard) {
                  eventTracker("event", PRODUCT_CLICKED, {
                    pagename:
                      location.pathname === "/"
                        ? "homepage"
                        : location.pathname,
                    product_type: item.aryaCertified
                      ? "certified_product"
                      : "noncertified_product",
                  });
                }
                similarLeadCard
                  ? onCardClick(e, item.createdById, item.id)
                  : onCardClick();
              }}
              data={item}
              className={cardClassName}
              isCardBottomRounded={isCardBottomRounded}
              showBookMark={showBookMark}
              aryaCertifiedCSS={aryaCertifiedCSS}
              bookmarked={item?.isBookMarked}
              onHeartClick={(e) => onHeartClick(e, item.lead_id)}
              bookMarkClass={bookMarkClass}
              widget={props.widget}
              locationText1ClassName={locationText1ClassName}
              locationText2ClassName={locationText2ClassName}
              desktopAddressOneLine={desktopAddressOneLine}
              isWarehouseDesktop={isWarehouseDesktop}
            />
          );
        })}
      </div>
      <ScrollDeskArrow
        scrollRef={scrollRef}
        scrollEnd={scrollEnd}
        setscrollEnd={setscrollEnd}
        scrollX={scrollX}
        setscrollX={setscrollX}
        leftArrowClassName={
          props.leftArrowClassName ?? style["left-arrow-desktop"]
        }
        rightArrowClassName={
          props.rightArrowClassName ?? style["right-arrow-desktop"]
        }
      />
    </div>
  );
};
export default CommonSupplies;
